import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../../login/authentication.service'

import { MenutitleService } from '../../../shared/menutitle.service';
import { ShowmenuService } from '../../../shared/showmenu.service';
import { Router, ActivatedRoute } from '@angular/router';

import { UnixtimeService } from '../../../shared/unixtime.service';
import { BeepService } from '../../../shared/beep.service';
import { VibrateService } from '../../../shared/vibrate.service';

import { NgxIndexedDBService } from 'ngx-indexed-db';

import { MenucontentService } from '../../../shared/menucontent.service';

@Component({
  selector: 'app-mass-start',
  templateUrl: './mass-start.component.html',
  styleUrls: ['./mass-start.component.css'],
})
export class MassStartComponent implements OnInit {
  loading = false;
  current_mass_start_id: string;
  current_mass_start_name: string;
  event_name: string;
  timing_json: any;

  start_race() {
    /*
    var item = {
      type: 'time', 
      client_id: localStorage.getItem("global_client_id"),
      device_id: localStorage.getItem("global_device_id"),
      client_pin: localStorage.getItem("global_client_pin"),
      mass_start_id: localStorage.getItem("global_mass_start_id"),
      stage_type: localStorage.getItem("global_stage_type"),
      race_number: '', 
      tagged_time: unix_time_now(),
      user_name: localStorage.getItem("global_user_name"),
    };
    */

    this.BeepService.beep();
    this.VibrateService.vibrate();

    var unix_time = this.UnixtimeService.unixtime();

    this.timing_json = {
      type: 'time',
      client_id: localStorage.getItem('global_client_id'),
      device_id: localStorage.getItem('global_device_id'),
      client_pin: localStorage.getItem('global_client_pin'),
      mass_start_id: localStorage.getItem('current_mass_start_id'),
      stage_type: 'Mass Start',
      race_number: '',
      tagged_time: unix_time,
      user_name: localStorage.getItem('global_user_name'),
    };

    this.dbService
      .add('timingmobi', {
        json: this.timing_json,
      })
      .subscribe((key) => {
        //console.log('key: ', key);

        var mass_start_id = localStorage.getItem('current_mass_start_id');
        var start_json_array = {};

        if (JSON.parse(localStorage.getItem('global_start_json'))) {
          start_json_array = JSON.parse(
            localStorage.getItem('global_start_json')
          );
        }

        start_json_array[mass_start_id] = [
          unix_time,
          localStorage.getItem('global_user_name'),
        ];

        localStorage.setItem(
          'global_start_json',
          JSON.stringify(start_json_array)
        );

        this.router.navigate([
          '/mass-start-done/' +
            mass_start_id +
            '/' +
            this.current_mass_start_name,
        ]);
      });
  }

  constructor(
    private menutitle: MenutitleService,
    private AuthenticationService: AuthenticationService,
    private ShowmenuService: ShowmenuService,
    private route: ActivatedRoute,
    private router: Router,
    private UnixtimeService: UnixtimeService,
    private dbService: NgxIndexedDBService,
    private BeepService: BeepService,
    private VibrateService: VibrateService,
    private MenucontentService: MenucontentService
  ) {}

  ngOnInit(): void {
    this.AuthenticationService.check_logged_in()
    this.AuthenticationService.save_current_route()
    
    this.ShowmenuService.changeShowmenu(true);
    this.MenucontentService.changeMenuMassStart();
    this.MenucontentService.changeMenuIndividualStart();
    this.MenucontentService.changeCheckpoints();

    this.menutitle.changeMenutitle('Start a race');
    this.menutitle.showMenupink(false);

    this.current_mass_start_id = localStorage.getItem('current_mass_start_id');
    this.current_mass_start_name = localStorage.getItem(
      'current_mass_start_name'
    );

    this.route.paramMap.subscribe((params) => {
      this.event_name = params.get('event_name');
    });
  }
}

// https://www.tektutorialshub.com/angular/angular-observable-tutorial-using-rxjs/
